import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    Grid,
    Card,
    CardContent,
    Box,
    Typography,
    Skeleton
} from '@mui/material';
import {
    History as HistoryIcon,
    TrendingUp as TrendingUpIcon,
    TrendingDown as TrendingDownIcon,
    AccountBalance as BalanceIcon
} from '@mui/icons-material';
import { transformToBTC } from '../../../../utils/helpers';

const UserStatsOverview = ({ userData, loading }) => {
    const { t } = useTranslation();

    const StatCard = ({ icon, value, label, color, loading }) => (
        <Card>
            <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {loading ? (
                        <Skeleton variant="circular" width={24} height={24} sx={{ mr: 2 }} />
                    ) : (
                        React.cloneElement(icon, { sx: { color, mr: 2 } })
                    )}
                    <Box>
                        <Typography variant="h4" sx={{ fontWeight: 700, color }}>
                            {loading ? (
                                <Skeleton variant="text" width={80} height={40} />
                            ) : (
                                value
                            )}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {loading ? (
                                <Skeleton variant="text" width={120} height={20} />
                            ) : (
                                label
                            )}
                        </Typography>
                    </Box>
                </Box>
            </CardContent>
        </Card>
    );

    return (
        <Grid container spacing={3} sx={{ mb: 4 }}>
            <Grid item xs={12} sm={6} md={3}>
                <StatCard
                    icon={<HistoryIcon />}
                    value={userData?.totalTransactions || 0}
                    label={t('user.totalTransactions')}
                    color="#1976d2"
                    loading={loading}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
                <StatCard
                    icon={<TrendingUpIcon />}
                    value={userData?.totalDeposits || 0}
                    label={t('user.deposits')}
                    color="#4caf50"
                    loading={loading}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
                <StatCard
                    icon={<TrendingDownIcon />}
                    value={userData?.totalWithdrawals || 0}
                    label={t('user.withdrawals')}
                    color="#f44336"
                    loading={loading}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
                <StatCard
                    icon={<BalanceIcon />}
                    value={loading ? '' : `${ userData?.netBalance >= 0 ? '+' : '' }${ transformToBTC(userData?.netBalance || 0) }`}
                    label={t('user.netBalance')}
                    color={userData?.netBalance <= 0 ? '#4caf50' : '#f44336'}
                    loading={loading}
                />
            </Grid>
        </Grid>
    );
};

export default UserStatsOverview;
